import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { logWithAmplitude } from '../helpers/api/api';
import { undefinedIfEmpty } from '../helpers/utils';
import { getMainPage } from '../helpers/page-name';

@customElement('copy-link-component')
export class CopyLinkComponent extends LitElement {
    static amplitude_callsite: string = 'Copy Link Button';


    @property({ type: String })
    text: string | undefined;

    @property({ type: String })
    error: string = 'An error has occurred.  Context: could not copy content. Try again later.';

    @property({ type: String })
    undefinedMessage: string = 'Please copy url manually for now.';

    @property({ type: String })
    successMessage: string = 'Text copied to clipboard.';

    @property({ type: String })
    textType: string | undefined;

    @property({ type: String })
    pageName: string | undefined;

    @property({ type: Boolean })
    showLabel: boolean = true;

    @property({ type: Boolean })
    small: boolean = false;

    render() {
        return html`
            <form-input-button style="${this.small ? 'height:30px;' : ''}"
                .value="${this.text ?? ''}"
                @submit="${this.copyText}">
                <slot></slot>
            </form-input-button>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    async copyText() {
        const text = undefinedIfEmpty(this.text);
        await getMainPage().errorToastElement.tryOrErrorToast(async () => {
            if (text === undefined) {
                getMainPage().errorToastElement.showToast(this.undefinedMessage);
                return;
            }
            await navigator.clipboard.writeText(text);
            getMainPage().errorToastElement.showToast(this.successMessage);
        }, this.error);

        // Melinda needs to fix not working as expected: textType is coming through as Undefined
        logWithAmplitude(
            CopyLinkComponent.amplitude_callsite,
            `Copy ${this.textType ?? ''} Link: ${this.pageName ?? ''}`
        );
    }
}
